import * as React from 'react';
import { Dispatch } from 'redux';
import { GetDetailsFromParticipantRequest } from 'stageclip-common';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class MergeParticipantsRequest extends BaseApiPatchRequest<
  GetDetailsFromParticipantRequest,
  EntityNormalizers.NormalizedSingleEntity<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(
    participantId: string,
    formData: GetDetailsFromParticipantRequest,
    component: React.Component,
    dispatch: Dispatch,
  ) {
    super(formData, component, dispatch);
    this.path = `/participants/${participantId}/merge-participants`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipant;
  }
}
